// extracted by mini-css-extract-plugin
export default {"inputDiv":"Whitelist_inputDiv__sTQX6","pageFooter":"Whitelist_pageFooter__7rsHq","footerLink":"Whitelist_footerLink__2Rkdj"};